export default "__VITE_ASSET__DOfJpBw$__"